/**
 * The types of VoidReasonMessage.
 *
 * @class VoidReasonMessageTypes
 * @name types
 * @memberof Mojito.Presentation.Components.VoidReasonMessage
 */
export default class VoidReasonMessageTypes {}

/**
 * Types of the reasons why a selection can be voided.
 *
 * @readonly
 * @enum {string}
 * @memberof Mojito.Presentation.Components.VoidReasonMessage.types
 */

VoidReasonMessageTypes.VOID_REASONS = {
    MARKET_RULES: 'MARKET_RULES',
    MATCH_ABANDONED: 'MATCH_ABANDONED',
    PALPABLE_ERROR: 'PALPABLE_ERROR',
    PUSHED: 'PUSHED',
    UNKNOWN: 'UNKNOWN',
    EVENT_DATE_CHANGED: 'EVENT_DATE_CHANGED',
    CHANGE_OF_EVENT_DATE: 'CHANGE_OF_EVENT_DATE',
    COMPLIANCE: 'COMPLIANCE',
    GOODWILL: 'GOODWILL',
    INCORRECT_INFORMATION: 'INCORRECT_INFORMATION',
    LATE_BET: 'LATE_BET',
    FEED: 'FEED',
    OTHER: 'OTHER',
};
